import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main-container" }

import { getCurrentInstance, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getArrDiffItems } from '@/utils/index'
import { GroupM, UserM } from '@/models/user'
import { getGroupListApi, getUserListApi } from '@/apis/user'
import { getContractWarningApi, saveContractWarningApi } from '@/apis/contract'

interface FormData {
    group_ids: number[],
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractWarning',
  setup(__props) {

const router = useRouter()
const { proxy } = getCurrentInstance() as any

const formData = reactive<FormData>({
    group_ids:  [], // 角色IDS
})

// 初始化页面数据
const initData = async () => {
    onGetGroupList() // 获取角色列表
    const {code, data, msg} = await getContractWarningApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    const { group_ids, user_list } = data
    if (group_ids) {
        formData.group_ids = group_ids.toString().split(',')
        userList.value = user_list
    }
}

// 角色列表
const groupList = ref<GroupM[]>([])
const onGetGroupList = async () => {
    const { code, msg, data } = await getGroupListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    groupList.value = data
}
// 监听选中角色列表变化
watch(() =>formData.group_ids, (newVal:any, oldVal:any) => {
    if (oldVal.length==0 && userList.value.length) { return } // 解决反显时 group_ids 发生变化，userList 渲染两次的问题
    let diffItem = getArrDiffItems(newVal, oldVal)[0] // 找出差异项
    oldVal.indexOf(diffItem)===-1 ? addUsers(diffItem) : removeUsers(diffItem) // 判断是进行新增还是移除
}, { immediate: false })

// 用户列表
const userList = ref<UserM[]>([])
// 根据角色 ID 批量增加用户
const addUsers = async (id:number) => {
    const {code, data, msg} = await getUserListApi({group_id: id}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    data.map((item:any) => item.group_id = id)
    userList.value = [...new Set(userList.value.concat(data))]
}
// 根据角色 ID 批量移除
const removeUsers = (id:number) => {
    userList.value = userList.value.filter(item => item.group_id != id)
}
// 根据用户 ID 移除指定项
const removeUser = (id:number) => {
    userList.value.splice(userList.value.findIndex(item => item.id === id), 1)
}

// 数据提交
const submitForm = async () => {
    const { group_ids } = formData
    const {code, data, msg} = await saveContractWarningApi({ group_ids: group_ids.join(','), user_list: userList.value.length ? JSON.stringify(userList.value) : ''}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '保存成功' })
    router.go(-1)
}
// 数据重置
const resetForm = () => {
    formData.group_ids = []
    userList.value = []
}

initData()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "form",
      ref: "channelForm",
      model: formData,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "角色：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formData.group_ids,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.group_ids) = $event)),
              multiple: "",
              filterable: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.title,
                    value: ''+item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "人员：" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "tag-row" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_tag, {
                    class: "mx-1",
                    closable: "",
                    onClose: ($event: any) => (removeUser(item.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.username), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClose"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (resetForm()))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("重置")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm()))
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("保存")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})